import { render } from "./SliderPage.vue?vue&type=template&id=4fcd3545&scoped=true"
import script from "./SliderPage.vue?vue&type=script&lang=js"
export * from "./SliderPage.vue?vue&type=script&lang=js"

import "./SliderPage.vue?vue&type=style&index=0&id=4fcd3545&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcd3545"]])

export default __exports__